const awsmobile =  {
    "aws_appsync_graphqlEndpoint": process.env.REACT_APP_AWS_GRAPHQL_ENDPOINT,
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
};

export default awsmobile;